export default __webpack_public_path__ + "src/img/articles/news-slider//men.png";